export function toNamedParams(fn) {
  return (state, getters, rootState, rootGetters) =>
    fn({
      state,
      getters,
      rootState,
      rootGetters,
    });
}
